import React, { useState } from "react";
import Input from "../Elements/Input/Input";
import Button from "../Elements/Button/Button";
import Loading from "../../Loader/Loader";
import "./Forgot.css";

export default Forgot = () => {

	const [email, setEmail] = useState('');
	const [isWaitingAnswer, setIsWaitingAnswer] = useState(false);
	const [errors, setErrors] = useState({
		email: '',
	});
	const [existsError, setExistsError] = useState(false);
	const [answerText, setAnswerText] = useState('');
	const { be } = errors;

	return (
		<div className="forgotWrapper">
			<div className="logo-icon-dark center-logo" />
			{
				isWaitingAnswer &&
				<div className="loaderWrapper">
					<Loading width={100} />
				</div>
			}
			{
				!isWaitingAnswer &&
				<>
					<h2 className="formTitle">Восстановление пароля</h2>
					<Input
						labelText="Введите e-mail"
						type="text"
						placeholder="miss1265@gmail.com"
						required={true}
						setValue={setEmail}
						errorText={errors.email}
						width="400px"
						existsError={existsError}
						setExistsError={setExistsError}
					/>
					{answerText !== '' && <span className="beckEndSuccess">{answerText}</span>}
					{typeof be !== 'undefined' && <span className="beckEndError">{be}</span>}
					<Button 
						type="button" 
						value="Отправить запрос" 
						fields={{email}} 
						setIsWaitingAnswer={setIsWaitingAnswer}
						method="forgot"
						validate={setErrors}
						existsErrors={setExistsError}
						setAnswerText={setAnswerText}
					/>
				</>
			}
		</div>
	);
}
